/**
 * EL SELLO DE VERIFICACION DE UN NODO (SALV-T9, Ares #20511).
 *
 * Josse verifica los nodos del arbol (nexo_catalogs.project_items) mirandolos en #/projects/:key, y hasta hoy el panel
 * no pintaba en ninguna parte quien verifico cada uno ni cuando: sin la marca no podia saber que le faltaba mirar.
 * Medido el 30-sep sobre 465 nodos: verificado_por en 223 (texto libre: quien y como), verificado_at en 184, dueno en
 * curated_by 243 / autor 86 / owner 19, y sin_verificar (texto: lo que quedo sin comprobar) en 12.
 *
 * Puro: sin DOM. Lo mide scripts/check-nodo-verificado.mjs.
 *
 * @module domain/verificacionNodo
 */

const texto = (v) => (typeof v === 'string' ? v.trim() : '');

/**
 * @param {object} meta  metadata del nodo (ya parseada)
 * @returns {{verificado:boolean, quien:string, cuando:string, falta:string}}
 *   verificado = hay un verificado_por con texto; cuando = verificado_at tal cual viene (fecha o fecha-hora), '' si no
 *   hay; falta = sin_verificar (lo que el que verifico dijo que NO comprobo), '' si no hay.
 */
export function selloDeVerificacion(meta) {
  const m = meta && typeof meta === 'object' ? meta : {};
  const quien = texto(m.verificado_por);
  return { verificado: quien.length > 0, quien, cuando: texto(m.verificado_at), falta: texto(m.sin_verificar) };
}

/** El dueno del nodo: owner, o quien lo curo, o su autor. '' si no se sabe. */
export function duenoDelNodo(meta) {
  const m = meta && typeof meta === 'object' ? meta : {};
  return texto(m.owner) || texto(m.curated_by) || texto(m.autor);
}

/** '2026-09-16T17:20-05:00' -> '16-sep 17:20'; '2026-09-30' -> '30-sep'; lo que no se entiende, tal cual. */
export function cuandoLegible(cuando) {
  const c = texto(cuando);
  const m = c.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2}))?/);
  if (!m) return c;
  const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  const mes = MESES[Number(m[2]) - 1];
  if (!mes) return c;
  return `${Number(m[3])}-${mes}${m[4] ? ` ${m[4]}:${m[5]}` : ''}`;
}
